import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { breakpoint } from '~/styles/themes';

export const Container = styled.div`
  ${({ theme }) => css`
    position: relative;
    width: 100%;
    max-width: ${breakpoint.mobile_large};
    margin: 0 auto;
    padding: ${theme.layout.chat_header_height} 0
      ${theme.layout.chat_navigation_height};
  `}
`;

export const ImageContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const SubTitle = styled.h2`
  ${({ theme }) => css`
    color: ${theme.content.content_light_1};
    ${theme.fontStyle.poppins.main}
  `}
`;

export const MoreText = styled.p`
  ${({ theme }) => css`
    display: inline-flex;
    align-items: center;
    padding-right: 16px;
    color: ${theme.themeColor.main_light};
    ${theme.fontStyle.text.body16_medium};
    cursor: pointer;
    gap: 4px;
  `}
`;

export const CharacterCard = styled.div`
  ${({ theme }) => css`
    position: relative;
    height: 280px;
    border: 1px solid transparent;
    cursor: pointer;

    &.on {
      border: 1px solid red;
    }

    img {
      width: 100%;
      height: 100%;
    }
    ${theme.mediaQuery.mobile_768} {
      height: 250px;
    }
  `}
`;

export const GroupChatTypeContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const GroupChatTypeWrapper = styled.div`
  display: flex;
  gap: 8px;
`;

export const GroupChatTypeButton = styled.button<{ selected: boolean }>`
  ${({ theme, selected }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 4px 16px;
    border-radius: 15px;
    background: ${theme.backgroundColor.bg_dark_2};
    color: ${theme.content.content_light_3};
    gap: 8px;
    backdrop-filter: blur(50px);
    ${theme.fontStyle.text.body16_medium};
    text-transform: capitalize;

    ${selected &&
    css`
      border-radius: 15px;
      background: ${theme.content.content_light_1};
      color: ${theme.content.content_dark_1};
      backdrop-filter: blur(50px);
    `}
  `}
`;
